import React, { useEffect, useState } from "react";
import axios from 'axios';
import documentData from "../../types/document.type";
import frontDoc from '../../assets/images/frontDoc.svg';
import loading from '../../assets/images/loading.gif';
import vacio from '../../assets/images/vacio.png';
import error from '../../assets/images/attentionIcon.svg';
import success from '../../assets/images/successIcon.svg';
import errorFace from '../../assets/images/errorFace.svg';
import DocumentsService from "../../services/documents.service";
import Swal from 'sweetalert2';

type Props = {
  type: string;
  label:string;
  customerId:string
};

function InputFile({ type,label,customerId }: Props) {
  
  useEffect(() => {
    checkStatus(type, customerId)
  }, []);

  const checkStatus = (type: string,customerId:string,) => {

    if (localStorage.getItem('token')=== undefined || localStorage.getItem('token')=== null) {
      DocumentsService.generateToken()
      setTimeout(() => {
        checkStatus(type, customerId)
      }, 500);
    }else{
      DocumentsService.checkStatus(customerId, type)
      .then((response: any) => {
        if (response.data) {
          setState({
            hasFile: true,
            imageStatus: response.data.imageStatus ? response.data.imageStatus : "",
            pendingTries: + 1
          });
          if (response.data.imageStatus === 'PENDING' || response.data.imageStatus === 'PROCESSING') {
            setTimeout(() => {
              checkStatus(response.data.imageType, customerId)
            }, 3000);
            setInputImage(response.data.imageStatus)
          }
          if (response.data.imageStatus === 'INVALID') {
            setInputImage(response.data.imageStatus)
            localStorage.setItem(`${response.data.imageType}`, response.data.imageStatus ? response.data.imageStatus : "");
            setTries(tries + 1);
            localStorage.setItem(`${response.data.imageType}_TRIES`, tries.toString());

          } else {
            setInputImage(response.data.imageStatus)
            localStorage.setItem(`${response.data.imageType}`, response.data.imageStatus ? response.data.imageStatus : "");
          }
        }
      })
      .catch((e: Error) => {
        console.log('El error es ' + e);
        window.location.reload();
      });
    }
   }

  const [inputState, setState] = useState({
    hasFile: false,
    imageStatus :"",
    pendingTries: 0
  });

  useEffect(() => {
    if (localStorage.getItem('token')=== undefined || localStorage.getItem('token')=== null) {
      DocumentsService.generateToken()
    }
  },[]);

  const [file, setFile] = useState("");

  const [style, setStyle] = useState("w-full flex bg-gray-50 border border-gray-300 rounded-full p-3  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white ");
  const [tries, setTries] = useState(0);

  const setInputImage = (imageStatus:string | undefined) => {

    switch (imageStatus) {
      
      case "INVALID":
        setFile(error);
        setStyle("w-full flex bg-gray-50 shakeError border border-red-400 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white");
        break;
      case "":
        setFile(vacio);
        setStyle("w-full flex bg-gray-50 border border-gray-300 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white");
        break;
      case "PROCESSING" || "PENDING":
        setStyle("w-full flex bg-gray-50 border border-gray-300 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white");
        setFile(loading);
        break;
      case "VALID":
        setFile(success);
        setStyle("w-full flex bg-gray-50 border border-green-400 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white");
        break;
      default:
        break;
    }
  };

  async function upload(imgData: any, type: string) {

    setInputImage("PROCESSING")
    setState({
      hasFile: true,
      imageStatus: "",
      pendingTries: 0
    });
    const docData: documentData = {
      imageType: type,
      data:imgData
    }
    DocumentsService.uploadDocument(docData, customerId)
    .then((response: any) => {
      if (response.data) {
        if (response.data.imageStatus === 'PENDING' || response.data.imageStatus === 'PROCESSING') {
          setTimeout(() => {
            checkStatus(response.data.imageType, customerId)
          }, 3000);
          setInputImage(response.data.imageStatus)
        } else {
          setInputImage(response.data.imageStatus)
        }
      }
    })
    .catch((e: Error) => {
      if (axios.isAxiosError(error)) {
        if ( error.response?.data.message === "customer.image.type.invalid") {
          Swal.fire({
            title: '¡Ooops!',
            text:"El archivo que intentas subir no es válido",
            imageUrl: errorFace,
            imageWidth: 150,
            imageHeight: 150,
            imageAlt: 'Custom image',
          })
        }
      } else {
        setState({
          hasFile: false,
          imageStatus: "PROCESSING",
          pendingTries: 0
        });
        Swal.fire({
          title: '¡Ooops!',
          text:"Ha ocurrido un error al subir el archivo",
          imageUrl: errorFace,
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: 'Custom image',
        })
       return
      }
    });
  }
  function compressImage(file: File, maxWidth: number, maxHeight: number, quality: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
  
      img.onload = () => {
        let width = img.width;
        let height = img.height;
  
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
  
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
  
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
  
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);
  
        const dataUrl = canvas.toDataURL(file.type, quality);
        resolve(dataUrl);
      };
  
      img.onerror = (error) => {
        reject(error);
      };
  
      img.src = URL.createObjectURL(file);
    });
  }
  const SetDocument = (e: any) => {
    
    const docType = e.target.name;
    const file = e.target.files[0];
    const fileSize = file.size;
    console.log('El tamaño del archivo es ' + fileSize + ' bytes')
    const fileMb = fileSize / 1024 ** 2;
    if (fileMb >= 2) {
      Swal.fire({
        title: '¡Ooops!',
        text:"La imagen de tu documento es muy pesado. Subí un archivo más liviano o comprimilo.",
        imageUrl: errorFace,
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: 'Error',
      })
      return;
    }
    const width = 500;
    const height = 500;
    compressImage(file, width, height, 0.75).then((compressedResult) => {
      console.log(compressedResult)
      const base64 = compressedResult?.toString().split(',')[1];
      upload(base64, docType);
    });
  }

  return (
    <div>
       <div className= {style}>
                <div className="w-1/6">
                  <img src={type === "FRONT_DOC" ? frontDoc : frontDoc} className="mx-auto" alt="Wally" />
                </div>
                <div className="w-4/6 ">
                  <div className="button-wrapper">
                    <span className="label text-xl sm:text-sm text-gray-500">
                   {label}
                    </span>
                      <input
                        onChange={SetDocument} 
                        disabled = {inputState.imageStatus === "VALID" || tries > 3 }
                        type="file"
                        name={type}
                        className="upload-box "
                        placeholder="Upload File"
                        accept="image/png, image/jpeg"
                        />
                  </div>
                </div>
                <div className="w-1/6">
                  <img src={file}  className={inputState.hasFile ? 'mx-auto h-7' : 'mx-auto hidden h-7'} alt="Wally" />
                </div>
        </div>
        {inputState.imageStatus === "INVALID" && tries < 4 ? <p className="text-red-500 text-center text-sm mt-1">Vuelve a intentarlo</p> : null}
    </div>
  );
}

export default InputFile;